export const receptionTypeValues = Object.freeze({
  PURCHASE: 'purchase',
  AUCTION: 'auction',
  SALES_ORDER: 'sales_order',
  EXPERT: 'expert',
})
export const getReceptionTypeLabel = (value, t) => {
  const options = receptionTypeOptions(t)
  const values = Array.isArray(value) ? value : value ? [value] : []
  return values
    .map(v => options.find(o => o.value === v)?.title)
    .filter(Boolean)
    .join(', ')
}

export const getPurposeOfSaleLabel = (value, t) => {
  const options = purposeOfSaleOptions(t)
  const values = Array.isArray(value) ? value : value ? [value] : []
  return values
    .map(v => {
      // First check in purposeOfSaleOptions (legacy purposes)
      const found = options.find(o => o.value === v)?.title
      if (found) return found

      // Fallback: translate expert service types directly
      // (gemmologist, goldsmith, certificates, other)
      const translated = t(v)
      return translated !== v ? translated : null
    })
    .filter(Boolean)
    .join(', ')
}

export const formatReceptionLabels = (types, purposes, t) => {
  const typeLabel = getReceptionTypeLabel(types, t)
  const purposeLabel = getPurposeOfSaleLabel(purposes, t)
  return [typeLabel, purposeLabel].filter(Boolean).join(', ')
}

export const receptionStatusValues = Object.freeze({
  CREATED: 'created',
  READY_TO_SEND: 'ready_to_send',
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  COMPENSATED: 'compensated',
})

export const receptionStatusOptions = t => [
  { title: t('created'), value: receptionStatusValues.CREATED },
  { title: t('readyToSend'), value: receptionStatusValues.READY_TO_SEND },
  { title: t('sentWaitingForAnswer'), value: receptionStatusValues.PENDING },
  { title: t('accepted'), value: receptionStatusValues.APPROVED },
  { title: t('rejected'), value: receptionStatusValues.REJECTED },
  { title: t('compensated'), value: receptionStatusValues.COMPENSATED },
]

export const getReceptionStatusLabel = (status, t) =>
  receptionStatusOptions(t).find(({ value }) => value === status)?.title

export const paymentMethodValues = Object.freeze({
  CASH: 'cash',
  BANK_TRANSFER: 'bank_transfer',
})

export const paymentMethodOptions = t => [
  { title: t('cash'), value: paymentMethodValues.CASH },
  { title: t('bankTransfer'), value: paymentMethodValues.BANK_TRANSFER },
]

export const receptionTypeOptions = t => [
  { title: t('toSell'), value: receptionTypeValues.PURCHASE },
  { title: t('toAuction'), value: receptionTypeValues.AUCTION },
  { title: t('salesOrder'), value: receptionTypeValues.SALES_ORDER },
  { title: t('expertServices'), value: receptionTypeValues.EXPERT },
]

export const purposeOfSaleValues = Object.freeze({
  EVALUATION: 'evaluation',
  ESTATE_INVENTORY: 'estate_inventory',
  INSURANCE_EVALUATION: 'insurance_evaluation',
  GEMMOLOGICAL_EXAMINATION: 'gemmological_examination',
  SALES_ORDER: 'sales_order',
  OTHER: 'other',
})

export const purposeOfSaleOptions = t => [
  {
    title: t('evaluation'),
    value: purposeOfSaleValues.EVALUATION,
  },
  {
    title: t('salesOrder'),
    value: purposeOfSaleValues.SALES_ORDER,
  },
  {
    title: t('estateInventory'),
    value: purposeOfSaleValues.ESTATE_INVENTORY,
  },
  {
    title: t('insuranceEvaluation'),
    value: purposeOfSaleValues.INSURANCE_EVALUATION,
  },
  {
    title: t('gemmologicalExamination'),
    value: purposeOfSaleValues.GEMMOLOGICAL_EXAMINATION,
  },
  {
    title: t('other'),
    value: purposeOfSaleValues.OTHER,
  },
]

export const receptionStateValues = Object.freeze({
  OPEN: 'open',
  CLOSED: 'closed',
})

export const receptionStateOptions = t => [
  { title: t('open'), value: receptionStateValues.OPEN },
  { title: t('archived'), value: receptionStateValues.CLOSED },
]

export const receptionProductStatusValues = Object.freeze({ ACTIVE: 'active', INACTIVE: 'inactive' })

export const getReceptionStatusColor = value => {
  switch (value) {
    case receptionStatusValues.PENDING:
      return 'warning'
    case receptionStatusValues.APPROVED:
      return 'success'
    case receptionStatusValues.REJECTED:
      return 'error'
    default:
      return 'info'
  }
}

export const receptionProductStatusOptions = t => [
  { title: t('active'), value: receptionProductStatusValues.ACTIVE },
  { title: t('inactive'), value: receptionProductStatusValues.INACTIVE },
]

export const receptionEntity = Object.freeze({
  seller: '',
  receptionDate: '',
  personnelAssigned: null,
  description: '',
  featuredImage: null,
  images: [],
  status: '',
  proposedPrice: null,
  proposalText: '',
  mightBuyProducts: false,
  hasProductsSoldOnBehalf: false,
  vatPercent: null,
  deadline: 14,
  state: receptionStateValues.OPEN,
  paymentMethod: null,
  accountNumber: '',
})
